import api from '../config/api';

const imageService = {
  async uploadImages(files, folder = 'products') {
    const formData = new FormData();
    files.forEach((file, i) => {
      formData.append('files', file, file.name || `image-${i}`);
    });
    if (folder) {
      formData.append('folder', folder);
    }

    // Let browser set Content-Type with boundary - remove default application/json
    const config = {
      transformRequest: [(data, headers) => {
        if (data instanceof FormData) {
          delete headers['Content-Type'];
        }
        return data;
      }],
    };

    try {
      const response = await api.post('/api/images/upload', formData, config);
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || err.response?.data?.Message || err.message;
      console.error('Image upload failed:', msg);
      throw new Error(msg || 'Failed to upload images');
    }
  },
};

export default imageService;
